import { render, staticRenderFns } from "./coaching-preview.vue?vue&type=template&id=453ebf4b&"
import script from "./coaching-preview.vue?vue&type=script&lang=js&"
export * from "./coaching-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports